import { Card } from 'common/components'

import './BenefitDetails.less'

interface BenefitInfoCardProps {
  title: string
  description: string | number
  completed?: boolean
  translate: (key: string) => string
}

const BenefitInfoCard = ({ title, description, completed, translate }: BenefitInfoCardProps) => {
  return (
    <Card>
      <div className="benefit_info_card flex flex__space_between">
        <h5>{title}</h5>
        {completed ? (
          <h5>{description}</h5>
        ) : (
          <h5 className="not_completed">{translate('admin-dashboard.benefit-details.summary.not-completed')}</h5>
        )}
      </div>
    </Card>
  )
}

export default BenefitInfoCard
